<div *cdkPortal style="width: 500px">
  <div class="triangle-up"></div>
  <app-onbording-card></app-onbording-card>
</div>
